/* jshint esversion: 6 */
import * as constants from 'app/redux/constants.js';
import { defaultState } from 'app/redux/defaultState.js';
import Utilities from 'app/utility/Utilities.js';

export const categories = (state = defaultState.categories, action) => {
    let nextState = Utilities.deepClone(state),
        i = 0,
        categories = [];

    if (action.status === constants.STATE_SUCCESS) {
        switch (action.type) {
            case constants.CATEGORY_LIST:
            case constants.CATEGORY_CREATE:
            case constants.CATEGORY_UPDATE:
                nextState = action.payload;
                break;

            case constants.CATEGORY_DELETE:
                for (i = 0; i < nextState.length; ++i) {
                    if (nextState[i].id != action.post.id) {
                        categories.push(nextState[i]);
                    }
                }
                nextState = categories;
                break;

            default:
                break;
        }
    }
    return nextState;
};
